import React from 'react';
import { useAlert } from '../context/AlertContext';
import { AlertCircle, CheckCircle } from 'lucide-react';
import './CustomAlert.css';

const CustomAlert = () => {
    const { alertState, hideAlert } = useAlert();
    const { isOpen, message, type, onConfirm, onCancel } = alertState;
    const [inputValue, setInputValue] = React.useState('');

    // 모달이 열릴 때마다 입력값 초기화
    React.useEffect(() => {
        if (isOpen) setInputValue('');
    }, [isOpen]);

    if (!isOpen) return null;

    const handleConfirm = () => {
        hideAlert();
        if (onConfirm) {
            // prompt 타입인 경우 입력값을 전달
            if (type === 'prompt') {
                onConfirm(inputValue);
            } else {
                onConfirm();
            }
        }
    };

    const handleCancel = () => {
        hideAlert();
        if (onCancel) onCancel();
    };

    return (
        <div className="custom-alert-overlay">
            <div className="custom-alert-content glass-card">
                <div className="custom-alert-header">
                    <AlertCircle size={20} className="alert-icon" />
                    <span className="alert-title">
                        {type === 'prompt' ? '보안 확인' : type === 'confirm' ? '확인' : '안내'}
                    </span>
                </div>
                <div className="custom-alert-body">
                    <p>{message}</p>
                    {type === 'prompt' && (
                        <input
                            type="password"
                            autoFocus
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleConfirm();
                            }}
                            placeholder="비밀번호(Master Key)를 입력하세요"
                            className="custom-alert-input"
                            style={{
                                width: '100%',
                                marginTop: '16px',
                                padding: '12px',
                                background: 'rgba(15, 23, 42, 0.6)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                borderRadius: '8px',
                                color: '#fff',
                                outline: 'none'
                            }}
                        />
                    )}
                </div>
                <div className="custom-alert-footer" style={{ gap: '12px', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    {(type === 'confirm' || type === 'prompt') && (
                        <button className="cancel-btn" onClick={handleCancel} style={{
                            flex: 1,
                            padding: '12px 20px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '8px',
                            color: '#94a3b8',
                            cursor: 'pointer',
                            fontWeight: '600'
                        }}>
                            취소
                        </button>
                    )}
                    <button className="confirm-btn" onClick={handleConfirm} style={{
                        flex: 1,
                        padding: '12px 20px',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        color: '#fff',
                        cursor: 'pointer',
                        fontWeight: '600'
                    }}>
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomAlert;
